import React from "react";
import { BarChart, Bar, XAxis, YAxis } from "recharts";
import styles from "./BarChartComponent.module.css";

const CustomBar = (props) => {
  const { fill, x, y, width, height } = props;

  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      fill="#ffffff"
      stroke={fill}
    />
  );
};
const BarChartComponent = ({ analyticsData }) => {
  if (!analyticsData) {
    return null;
  }
  const data = [
    { name: "Searched", cases: analyticsData?.chatsCount },
    { name: "Referred", cases: analyticsData?.casesCount },
    { name: "Solved by AI", cases: analyticsData?.solvedByAI },
    { name: "Solved by DR", cases: analyticsData?.solvedBySpecialist },
  ];
  return (
    <div className={styles.chart_parent}>
      <BarChart width={600} height={400} data={data}>
        {/* Remove or adjust CartesianGrid */}
        <XAxis dataKey="name" tick={{ fill: "#ffffff" }} />
        <YAxis
          tick={{ fontSize: 12, fill: "#ffffff" }}
          label={{
            value: "Cases",
            offset: 10,
            fill: "#ffffff",
            position: "insideLeft",
            angle: -90,
          }}
        />
        {/* <Tooltip wrapperStyle={{ color: "#ffffff" }} /> */}
        {/* <Legend wrapperStyle={{ color: "#ffffff" }} /> */}
        <Bar
          dataKey="cases"
          shape={<CustomBar />}
          label={{ position: "top", fill: "#ffffff" }}
          fill="#ffffff"
        />
      </BarChart>
    </div>
  );
};

export default BarChartComponent;
